import { render, staticRenderFns } from "./UserBranchWarehouseDialog.vue?vue&type=template&id=5287ce6e&scoped=true"
import script from "./UserBranchWarehouseDialog.vue?vue&type=script&lang=js"
export * from "./UserBranchWarehouseDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5287ce6e",
  null
  
)

export default component.exports